const nearley = require('nearley')
const grammar = require('./grammars/recipes.js')

export default class FormulaParser {
  constructor () {
    // Nearley's grammar compiler outputs UMD that can't be loaded from webpack for some reason.
    const compiledGrammar = typeof window !== 'undefined' && window.grammar ? window.grammar : grammar
    this.grammar = nearley.Grammar.fromCompiled(compiledGrammar)
    this.cache = {}
  }

  parse (formula) {
    if (formula in this.cache) {
      return this.cache[formula]
    }
    const parser = new nearley.Parser(this.grammar)
    parser.feed(formula)
    this.cache[formula] = parser.results
    return parser.results
  }

  traverseResult (parserResult, visit, start = () => {}, end = () => {}) {
    if (!parserResult) return
    const continueTraversing = visit(parserResult)
    if (parserResult.d && continueTraversing) {
      start(parserResult)
      parserResult.d.forEach(result => {
        this.traverseResult(result, visit, start, end)
      })
      end(parserResult)
    } else if (Array.isArray(parserResult)) {
      start(parserResult)
      parserResult.forEach(result => {
        this.traverseResult(result, visit, start, end)
      })
      end(parserResult)
    }
  }

  /**
   * Get all the variables of this formula parsing result.
   *
   * @param parserResult
   * @return {Set<any>}
   */
  getVars (parserResult) {
    const vars = new Set()
    const shadowingParameters = []
    this.traverseResult(parserResult, result => {
      if (result.type === 'Variable' && !shadowingParameters.flat().includes(result.identifier)) {
        vars.add(result.identifier)
      }
      return true
    }, start => {
      if (start.type === 'ArrowExpression') {
        const parameters = start.d[0].d[0].d.map(node => node.v)
        shadowingParameters.push([...parameters])
      }
    }, end => {
      if (end.type === 'ArrowExpression') {
        shadowingParameters.pop()
      }
    })
    return vars
  }
}
